/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Slogan_5_Text_4Inputs */



/**
* | output |
* | --- |
* | "Every action traceable." |
*
* @param {Auth_Slogan_5_Text_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_slogan_5_text_4 = /** @type {((inputs?: Auth_Slogan_5_Text_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Slogan_5_Text_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jede Aktion nachvollziehbar.")
	return /** @type {LocalizedString} */ ("Every action traceable.")
});